import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { WeeklyPayrollRequest } from '../../services/payrollService';

interface WeeklyPayrollDialogProps {
  open: boolean;
  onClose: () => void;
  onGenerate: () => void;
  loading: boolean;
  weeklyForm: WeeklyPayrollRequest;
  onFormChange: (form: WeeklyPayrollRequest) => void;
}

const WeeklyPayrollDialog: React.FC<WeeklyPayrollDialogProps> = ({
  open,
  onClose,
  onGenerate,
  loading,
  weeklyForm,
  onFormChange
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Generate Weekly Payrolls</DialogTitle>
      <DialogContent>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Week Starting"
            value={weeklyForm.weekStart ? new Date(weeklyForm.weekStart) : null}
            onChange={(newValue) => onFormChange({ 
              ...weeklyForm, 
              weekStart: newValue?.toISOString().split('T')[0] || ''
            })}
            sx={{ width: '100%', mt: 2 }}
          />
        </LocalizationProvider>
        
        <TextField
          fullWidth
          margin="normal"
          label="Overtime Threshold"
          type="number"
          value={weeklyForm.overtimeThreshold}
          onChange={(e) => onFormChange({ 
            ...weeklyForm, 
            overtimeThreshold: parseFloat(e.target.value) || 40 
          })}
        />
        
        <FormControlLabel
          control={
            <Checkbox
              checked={weeklyForm.includeOnlyCompletedShifts}
              onChange={(e) => onFormChange({ 
                ...weeklyForm, 
                includeOnlyCompletedShifts: e.target.checked 
              })}
            />
          }
          label="Include only completed shifts"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button 
          onClick={onGenerate} 
          variant="contained"
          disabled={loading || !weeklyForm.weekStart}
        >
          Generate Payrolls
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WeeklyPayrollDialog;
